export const bedCodeToName: Record<string, string> = {
  o001: "[응급실] 일반",
  o002: "[응급실] 소아",
  o003: "[응급실] 음압격리",
  o004: "[응급실] 일반격리",
  o005: "[입원][응급전용] 중환자실",
  o006: "[입원][중환자실] 내과",
  o007: "[입원][중환자실] 외과",
  o008: "[입원][중환자실] 신생아",
  o009: "[입원][중환자실] 소아",
  o010: "[입원][응급전용] 소아 중환자실",
  o011: "[입원][중환자실] 신경과",
  o012: "[입원][중환자실] 신경외과",
  o013: "[입원][중환자실] 화상",
  o014: "[입원] [외상전용] 중환자실",
  o015: "[입원][중환자실] 심장내과",
  o016: "[입원][중환자실] 흉부외과",
  o017: "[입원][중환자실] 일반",
  o018: "[입원][중환자실] 음압격리",
  o019: "[입원][응급전용] 입원실",
  o020: "[입원][응급전용] 소아 입원실",
  o021: "[입원] [외상전용] 입원실",
  o022: "[입원] [기타] 수술실",
  o023: "[입원] [외상전용] 수술실",
  o024: "[입원] [입원실] 정신과 폐쇄병동",
  o025: "[입원] [입원실] 음압격리",
  o026: "[입원] [기타] 분만실",
  o036: "[입원] [기타] 화상전용처치실",
  o038: "[입원] [입원실] 일반",
  o048: "[응급실] 소아음압격리",
  o049: "[응급실] 소아일반격리",
  o050: "[입원][응급전용] 중환자실 음압격리",
  o051: "[입원][응급전용] 중환자실 일반격리",
  o052: "[입원][응급전용] 입원실 음압격리",
  o053: "[입원][응급전용] 입원실 일반격리",
  o059: "[응급실] 코호트격리",
  o060: "[응급실] 외상소생실",
};
